<!--
 * @Author: AllezLRC 13636411941@163.com
 * @Date: 2025-03-27 11:03:36
 * @LastEditors: AllezLRC 13636411941@163.com
 * @LastEditTime: 2025-03-28 16:08:31
 * @FilePath: /wemeet-admin-new/src/views/recruitment/brand/SelectBrand.vue
 * @Description: 
 * Copyright (c) 2025 by WeMeet, All Rights Reserved. 
-->
<template>
  <div class="select-brand">
    <el-form inline>
      <el-form-item label="机构名称">
        <el-input v-model="name" @input="handleBrandNameInput" />
      </el-form-item>
    </el-form>

    <el-radio-group v-model="code" @change="($event) => emit('change', $event)">
      <el-radio v-for="brand in brandList" :key="brand.enterpriseCode" :label="brand.enterpriseCode">
        <div class="select-brand__radio">
          <el-image v-if="brand.logo" class="select-brand__img" :src="brand.logo" />
          <span>{{ brand.name }}</span>
        </div>
      </el-radio>
    </el-radio-group>
  </div>
</template>

<script setup>
  import { ref, defineEmits } from 'vue'
  import { debounce } from 'lodash'
  import { getAllEnterpriseList } from '@/api/brand'

  const name = ref('')
  const brandList = ref([])
  const code = ref()

  const emit = defineEmits(['change'])

  const handleBrandNameInput = debounce((enterpriseName) => {
    getAllEnterpriseList({
      enterpriseName,
      pageNum: 1,
      pageSize: 999,
    }).then(({ code, data }) => {
      if (code !== 200) return
      brandList.value = data.list
    })
  }, 300)
</script>

<style lang="scss" scoped>
  .select-brand {
    min-height: 180px;

    &__radio {
      height: 24px;
      display: flex;
      align-items: center;
    }

    &__img {
      width: 20px;
      height: 20px;
      margin-right: 8px;
    }
  }
</style>
